import { render, staticRenderFns } from "./check-choice.vue?vue&type=template&id=148a5c9b&scoped=true&"
import script from "./check-choice.vue?vue&type=script&lang=js&"
export * from "./check-choice.vue?vue&type=script&lang=js&"
import style0 from "./check-choice.vue?vue&type=style&index=0&id=148a5c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a5c9b",
  null
  
)

export default component.exports